module.exports = __webpack_public_path__ + "static/media/2-circle-occupied.27e4cc70.svg";